(function (window, document, undefined) {


  window.pGiftWrap = {


    addListeners: () => {

      let open_btns = document.querySelectorAll('[data-action="open--p_gift_wrap"]'),
          close_btns = document.querySelectorAll('[data-action="close--p_gift_wrap"]'),
          toggle_btns = document.querySelectorAll('[data-action="toggle--p_gift_wrap"]'),
          more_btn = document.querySelector('.p_gift_wrap .box__c__description_btn'),
          ov = document.querySelector('.p_gift_wrap__ov');
      
      if (open_btns.length) {
        [].forEach.call(open_btns, function(e) {
          e.addEventListener('click', () => {
            window.pGiftWrap.open();
          });
        });
      }

      if (close_btns.length) {
        [].forEach.call(close_btns, function(e) {
          e.addEventListener('click', () => {
            window.pGiftWrap.close();
          });
        });
      }

      if (toggle_btns.length) {
        [].forEach.call(toggle_btns, function(e) {
          e.addEventListener('click', () => {
            window.pGiftWrap.toggle();
          });
        });
      }

      if (ov) {
        ov.addEventListener('click', () => {
          window.pGiftWrap.close();
        });
      }

      if (more_btn) {
        more_btn.addEventListener('click', (e) => {
          window.animationSlideUp(e.target, 300);
          window.animationSlideDown(e.target.closest('.box__c').querySelector('.box__c__description'), 300);
        });
      }


    },


    open: () => {
      document.body.setAttribute('data-p-gift-wrap', '1');
    },


    close: () => {
      document.body.setAttribute('data-p-gift-wrap', '0');
    },


    toggle: () => {
      let current_value = document.body.getAttribute('data-p-gift-wrap');
      if (current_value == '0') {
        window.pGiftWrap.open();
      } else {
        window.pGiftWrap.close();
      }
    },


    init: () => {
      
      window.pGiftWrap.addListeners();

    }


  }


})(window, window.document);


window.pGiftWrap.init();
